<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineOptions({
    inheritAttrs: false,
});

defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    label: {
        type: String,
        default: null,
    },
});
</script>

<template>
    <Transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="visible"
            v-bind="$attrs"
            class="bg-neutrals-200 absolute inset-0 z-50"
        >
            <div class="bg-accent-200/20 text-accent absolute inset-0">
                <div
                    class="border-accent absolute inset-4 flex flex-col items-center justify-center gap-4 border border-dashed p-4"
                >
                    <CFIcon
                        name="download-thick-bottom"
                        size="80"
                    />
                    <span>{{ label ?? $t('support.drop_files_here') }}</span>
                </div>
            </div>
        </div>
    </Transition>
</template>
